import { render, staticRenderFns } from "./creatEQB.vue?vue&type=template&id=563cfe01"
import script from "./creatEQB.vue?vue&type=script&lang=js"
export * from "./creatEQB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports